import { TableBody } from "@mui/material"
import styled from "styled-components"

export const TBody = styled(TableBody)`
  overflow-y: visible;
`
